import { render, staticRenderFns } from "./monthFixRecord.vue?vue&type=template&id=56489f08&scoped=true&"
import script from "./monthFixRecord.vue?vue&type=script&lang=js&"
export * from "./monthFixRecord.vue?vue&type=script&lang=js&"
import style0 from "./monthFixRecord.vue?vue&type=style&index=0&id=56489f08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56489f08",
  null
  
)

export default component.exports